/**
 * 로그아웃 버튼 등에서 호출하는 훅. 학생 FE는 JWT(로그인 토큰)를 sessionStorage에 보관하는데
 * (관리자 FE는 localStorage라 정책이 다르다), 로그아웃 시 이 훅이 sessionStorage와 Recoil 상태를
 * 함께 정리한다.
 *
 * ★ 실행 순서 주의: 실제로는 서버에 로그아웃을 요청(await logout())하기 전에 먼저
 *   /login으로 화면을 이동시킨다. 사용자 입장에서 로그아웃 버튼을 누르면 곧바로 로그인
 *   화면이 보이게 하기 위한 의도적인 순서이고, 서버 요청과 상태 정리는 그 뒤에 이어진다.
 */
import { useCallback } from "react";
import { useRouter } from "next/router";
import { useResetRecoilState } from "recoil";
import { logout } from "pages/api/login/logout";
import { userState } from "@/recoil/atom";
import { useClearQuizState } from "./useClearQuizState";

/** 로그아웃 API 호출 및 상태 초기화 훅 */
export function useLogout() {
  const router = useRouter();

  // 각각의 Recoil 상태를 리셋할 수 있는 함수들 생성
  const resetUserInfoState = useResetRecoilState(userState);
  const { clearAllQuizState } = useClearQuizState();

  const handleLogout = useCallback(async () => {
    sessionStorage.setItem("isLoggingOut", "true");
    // 퀴즈 관련 모든 로컬 상태 초기화
    clearAllQuizState();

    router.replace("/login");
    await logout();

    // Recoil 상태 초기화
    resetUserInfoState();
    sessionStorage.clear(); // accessToken 등 모든 데이터 삭제
  }, [router, resetUserInfoState]);

  return handleLogout;
}
